import { useQuery } from 'react-query'
import { ApiService } from 'src/services/api.service'

export const GET_MEET_LINK_CACHE_KEY = 'get-meet-link'

export function useMeetLink(code?: string) {
  return useQuery([GET_MEET_LINK_CACHE_KEY, code], () => ApiService.MeetLinks.resolveMeetLink(code), {
    retry: 0,
    enabled: Boolean(code),
    refetchOnWindowFocus: false,
  })
}
